<template>
	<v-dialog v-model="dialog" max-width="370" persistent>
		<v-card>
			<v-card-title class="headline"> {{ title }}</v-card-title>
			<v-card-text>{{ text }}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="close">
					Cancelar
				</v-btn>
				<v-btn :loading="loading" color="error" text @click="confirm">
					Eliminar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		text: { type: String, default: '' },
		dialog: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		close: {
			type: Function,
			required: true,
		},
		confirm: {
			type: Function,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped></style>
